/* eslint-disable react-hooks/exhaustive-deps */
import {
  useEffect,
  useState
} from "react";
import {
  INICIAL
} from "../store/types/comprasTypes";

const config = {
  tipo: INICIAL,
  fields: {
    inicial: {
      codigo_control: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
      ice: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
      iehd: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
      ipj: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
      otros_no_dfiva: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
      tasas: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
      exportaciones: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
      tasa_cero: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
      gift_card: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
      descuentos: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
    },
    simple: {
      codigo_control: {
        show: false,
        valueDefault: "0",
        readOnly: true
      },
      ice: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      iehd: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      ipj: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      otros_no_dfiva: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      tasas: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      exportaciones: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      tasa_cero: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      gift_card: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      descuentos: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
    },
    computarizada: {
      codigo_control: {
        show: true,
        valueDefault: "",
        readOnly: false
      },
      ice: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      iehd: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      ipj: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      otros_no_dfiva: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      tasas: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      exportaciones: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      tasa_cero: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      gift_card: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
      descuentos: {
        show: false,
        valueDefault: "0.00",
        readOnly: true
      },
    },
  }
};


export const useTiposVentas = () => {
  const [tipo, setTipo] = useState(config.tipo);
  const [fields, setFields] = useState({
    ...JSON.parse(JSON.stringify(config.fields.inicial))
  });
  const changeTipo = t => setTipo(t);
  useEffect(() => {
    setFields({
      ...JSON.parse(JSON.stringify(config.fields[tipo]))
    })
  }, [tipo]);
  return {
    tipo,
    fields,
    changeTipo
  };
}